import React, { useState, lazy } from 'react';
import { PlayIcon, ChevronUpIcon, ArrowRightIcon } from 'lucide-react';
// CSS for the carousel
const carouselStyles = `
.carousel-tile{position:relative;isolation:isolate;}
.carousel-thumb{display:block;width:100%;aspect-ratio:16/9;object-fit:cover;position:relative;z-index:1;pointer-events:auto;}
.carousel-overlay{position:absolute;inset:0;pointer-events:none;}
`;
type Item = {
  id: string;
  title: string;
  quote: string;
  posterUrl: string;
  videoUrl: string;
};
export function VideoTestimonials({
  items,
  onPlay
}: {
  items: Item[];
  onPlay: (item: Item) => void;
}) {
  const [expanded, setExpanded] = useState(false);
  const visibleItems = expanded ? items : items.slice(0, 6);
  const remaining = items.length - 6;
  return <section className="w-full bg-gradient-to-br from-[#231232] to-[#1a0d24] py-16 border-b border-[#6805DA]/20" data-id="element-395">
      <style data-id="element-396">{`${carouselStyles}`}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-397">
        <div className="text-center mb-12" data-id="element-398">
          <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-4" data-id="element-399">
            HEAR FROM REAL PEOPLE
          </span>
          <h2 className="text-3xl sm:text-4xl font-outfit font-bold mb-6 text-white" data-id="element-400">
            Video Testimonials
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-401"></div>
        </div>
        {/* ONE persistent carousel */}
        <div className="
          relative
          grid gap-8
          grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
          [scroll-snap-type:x_mandatory] sm:[scroll-snap-type:unset]
          overflow-x-auto sm:overflow-x-visible pb-6 sm:pb-2
        " data-id="element-402">
          {visibleItems.map((item, idx) => <button key={item.id} type="button" onClick={() => onPlay(item)} className="carousel-tile snap-start sm:snap-none text-left group flex flex-col h-full" aria-label={`Play ${item.title}`} data-id="element-403">
              {/* Hover Backdrop Panel */}
              <div className="pointer-events-none absolute -inset-3 rounded-2xl bg-white/[0.03] border border-white/10 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10" data-id="element-404" />

              {/* Thumbnail + hover overlays */}
              <div className="relative overflow-hidden rounded-xl" data-id="element-405">
                <img className="carousel-thumb rounded-xl transition-transform duration-300 group-hover:scale-[1.01]" src={item.posterUrl} alt={item.title} loading={idx < 2 ? 'eager' : 'lazy'} fetchPriority={idx < 2 ? 'high' : 'auto'} data-id="element-406" />
                {/* Dim overlay */}
                <div className="pointer-events-none absolute inset-0 z-10 bg-black/25 opacity-0 group-hover:opacity-100 transition-opacity duration-[250ms] ease-out" data-id="element-407" />
                {/* Play button */}
                <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-[250ms] ease-out" data-id="element-408">
                  <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-md" data-id="element-409">
                    <PlayIcon size={24} className="text-[#231232] ml-0.5" fill="currentColor" data-id="element-410" />
                  </div>
                </div>
              </div>

              <div className="pt-6" data-id="element-411">
                <h4 className="font-manrope font-bold text-lg text-white mb-2" data-id="element-412">
                  {item.title}
                </h4>
                <p className="mt-auto text-gray-300 italic line-clamp-3" data-id="element-413">
                  "{item.quote}"
                </p>
              </div>
            </button>)}
        </div>

        {remaining > 0 && <div className="mt-8 flex justify-end" data-id="element-414">
            <button onClick={() => setExpanded(!expanded)} className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-white/70 text-sm hover:bg-white/10 transition-colors" data-id="element-415">
              {expanded ? <>
                  Collapse <ChevronUpIcon size={14} data-id="element-416" />
                </> : <>
                  +{remaining} more <ArrowRightIcon size={14} data-id="element-417" />
                </>}
            </button>
          </div>}
      </div>
    </section>;
}